export default __webpack_public_path__ + "assets/b3b5505d1af8d7b9ca9d46e3f92b949e.svg";